import { render, staticRenderFns } from "./GSwitchSmall.vue?vue&type=template&id=69217df9&"
import script from "./GSwitchSmall.vue?vue&type=script&lang=js&"
export * from "./GSwitchSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports